import React from 'react'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "../About/About.css"
import Visioni from "../../images/Content/vision.png";
const Vision = () => {
  return (
    <div className='div-desarrollo col-md-6' data-aos="fade-up" data-aos-delay="7000">
        <h1 className='titulo-servicio'> <img className='icono-titulo' src={Visioni} />Vision.<img className='icono-titulo' src={Visioni} /></h1>
        <p className="parrafo-servicio" style={ { color:"White",}}>Nuestra visión en NinnoTech es ser líderes en la creación de páginas web que combinan simplicidad y atractivo visual de manera excepcional. Nos esforzamos por ser reconocidos como el socio de confianza para aquellos que buscan sitios web que no solo sean funcionales, sino también estéticamente agradables. Buscamos transformar la percepción de la web, demostrando que la simplicidad puede ser poderosa y que la belleza puede coexistir con la funcionalidad en cada proyecto que emprendemos.</p>
        </div>
  )
}

export default Vision